import { render, staticRenderFns } from "./staOutpatient.vue?vue&type=template&id=506372fd&scoped=true"
import script from "./staOutpatient.vue?vue&type=script&lang=js"
export * from "./staOutpatient.vue?vue&type=script&lang=js"
import style0 from "./staOutpatient.vue?vue&type=style&index=0&id=506372fd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506372fd",
  null
  
)

export default component.exports